export var getEl=function(t){var e;return"string"==typeof t?null!==(e=document.getElementById(t))&&void 0!==e?e:void 0:t};